export default __webpack_public_path__ + "static/media/3.43c79a66.jpg";